module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.show, slideOutLeft: !_vm.show
    }
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n    Menu\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', [(item.path) ? _c('router-link', {
      attrs: {
        "to": item.path,
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          _vm.toggle(index, item)
        }
      }
    }, [(item.meta && item.meta.icon) ? _c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]) : _vm._e(), _vm._v(" "), (item.meta && item.meta.label) ? _c('span', [_vm._v(_vm._s(item.meta.label || item.name))]) : _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          _vm.toggle(index, item)
        }
      }
    }, [(item.meta && item.meta.icon) ? _c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]) : _vm._e(), _vm._v(" "), (item.meta && item.meta.label) ? _c('span', [_vm._v(_vm._s(item.meta.label || item.name))]) : _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]), _vm._v(" "), (item.children && item.children.length) ? _c('expanding', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(item)),
        expression: "isExpanded(item)"
      }]
    }, _vm._l((item.children), function(subItem) {
      return (subItem.path) ? _c('li', [_c('router-link', {
        attrs: {
          "to": _vm.generatePath(item, subItem)
        }
      }, [_vm._v("\n              " + _vm._s(subItem.meta && subItem.meta.label || subItem.name) + "\n            ")])], 1) : _vm._e()
    }))]) : _vm._e()], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46700251","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Sidebar.vue
// module id = 62
// module chunks = 4